import { GA_PRODUCT } from '@spotify-internal/s4mp-page-analytics';
import { AvailabilityStatus } from '@hooks/useAlbumInfo/types';

export const TOOLTIP_SUCCESS_DURATION_MS = 3000;

export const ATLAS_REDIRECT_LOCAL_STORAGE_KEY = 'atlasRedirect';

export const ONE_HOUR_IN_MS = 3600000;
export const TEN_MINUTES_IN_MS = 600000;

export enum SORT_DIRECTION {
  ascending = 'ascending',
  descending = 'descending',
}

export enum RELEASE_DATE_SORT {
  ASCENDING = 'ascending',
  DESCENDING = 'descending',
  NONE = 'none',
}

export const SEARCH_SORT_DIRECTION_DESC = 'SEARCH_SORT_DIRECTION_DESC';
export const SEARCH_SORT_DIRECTION_ASC = 'SEARCH_SORT_DIRECTION_ASC';

export const HELP_CENTER_URL =
  'https://atlas.spotifycdn.com/spotify_for_music_providers_onboarding.pdf';
export const DELIVERIES_IN_S4MP_URL =
  'https://musicproviders.spotify.com/deliveries';
export const MUSIC_VIDEO_US_CLEARANCE_FAQ_URL =
  'https://atlas.spotifycdn.com/music_video_us_clearance_faq.pdf';

export const VARIOUS_ARTIST_THRESHOLD = 4;

export const GA_PRODUCT_CATALOG = GA_PRODUCT.CATALOG;
export const AVAILABLE = 'Available';
export const UNAVAILABLE = 'Unavailable';

export const AVAILABLE_STATUSES = [
  AvailabilityStatus.DELIVERED,
  AvailabilityStatus.DELIVERED_FLAGGED,
];

export const IS_CLIENT_ENV = typeof window !== 'undefined';

export const DEFAULT_ROWS_PER_PAGE = [10, 25, 50];
export const DEFAULT_LIMIT = DEFAULT_ROWS_PER_PAGE[0].toString();
export const DEFAULT_PAGE = '1';
export const COLUMN_MAX_WIDTH = '975px';

// Tour cookie names
export const SEARCH_RESULTS_PAGINATION_TOUR_COOKIE =
  'searchResultsPaginationOnboardingVisible';

export const EMPTY_VALUE = '-';
